import type { DecimalValue } from 'skladon-types';

const parse = (value: DecimalValue | null | undefined): number | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const parsed = typeof value === 'number' ? value : Number(value);

    return Number.isFinite(parsed) ? parsed : null;
};

/** Peněžní hodnota jako desetinné číslo. */
export const toNumber = (value: DecimalValue | null | undefined): number | null => parse(value);

/** Množství jako celé číslo; desetinná část se zahazuje směrem k nule. */
export const toInt = (value: DecimalValue | null | undefined): number | null => {
    const parsed = parse(value);

    return parsed === null ? null : Math.trunc(parsed);
};

/**
 * Převod na číslo pro zápis do Core. Na rozdíl od `toNumber` zachovává `null`
 * i `undefined`, protože Core je rozlišuje (vymazat hodnotu vs. neměnit ji).
 */
export function toCoreNumber(value: DecimalValue): number;
export function toCoreNumber(value: DecimalValue | null): number | null;
export function toCoreNumber(value: DecimalValue | undefined): number | undefined;
export function toCoreNumber(value: DecimalValue | null | undefined): number | null | undefined;
export function toCoreNumber(value: DecimalValue | null | undefined): number | null | undefined {
    if (value === null || value === undefined) {
        return value;
    }

    return parse(value) ?? undefined;
}

/** Varianta `toCoreNumber` pro Core sloupce, které přijímají decimal jako řetězec. */
export function toCoreDecimalString(value: DecimalValue): string;
export function toCoreDecimalString(value: DecimalValue | null): string | null;
export function toCoreDecimalString(value: DecimalValue | undefined): string | undefined;
export function toCoreDecimalString(value: DecimalValue | null | undefined): string | null | undefined;
export function toCoreDecimalString(value: DecimalValue | null | undefined): string | null | undefined {
    if (value === null || value === undefined) {
        return value;
    }

    return String(value);
}
